export const ROUTES = Object.freeze({
  login: '/login',
  registration: '/account/register',
  approve: (hash) => `/account/register/${hash}`,
  approved: '/account/approved',
  approveResend: (email) => `/account/approve_resend/${email}`,
  finalize: (token) => `/account/finalize/${token}`,
  forgotPassword: '/account/forgot_password',
  resetPassword: (hash) => `/account/reset_password/${hash}`,
  approveChangeEmail: (hash) => `/account/approvechangeemail/${hash}`,
})
